import { DocumentProviderType } from 'models/documentProvider';
import DocumentOutputLocation, {
  DocumentOutputFolderRule,
  DocumentOutputLocationStatus,
  DocumentOutputLocationSummary,
  DocumentOutputPurpose,
} from 'models/documentOutputLocation';
import {
  DocumentOutputLocationDTO,
  DocumentOutputLocationFolderPutDTO,
  DocumentOutputLocationPutDTO,
  DocumentOutputLocationStatusDTO,
  DocumentOutputLocationSummaryDTO,
} from 'models/dto/documentOutputLocationDTO';

export function mapFromDocumentOutputLocation(dto: DocumentOutputLocationDTO): DocumentOutputLocation {
  const output = new DocumentOutputLocation();

  output.purpose = dto.purpose as DocumentOutputPurpose;
  output.listId = dto.listId;
  output.listName = dto.listName;
  output.listUrl = dto.listUrl;
  output.providerType = dto.providerType as DocumentProviderType | undefined;
  output.connectionId = dto.connectionId;
  output.connectionName = dto.connectionName;
  output.templateLinkId = dto.templateLinkId;
  output.templateName = dto.templateName;
  output.templateUrl = dto.templateUrl;
  output.templateInherited = dto.templateInherited === true;
  output.folderDriveItemId = dto.folderDriveItemId;
  output.folderName = dto.folderName;
  output.folderRule = dto.folderRule as DocumentOutputFolderRule;
  output.folderNameFormat = dto.folderNameFormat;
  output.allowedProviders = (dto.allowedProviders ?? []).map((providerType) => providerType as DocumentProviderType);

  return output;
}

export function mapFromDocumentOutputLocations(dtos: DocumentOutputLocationDTO[]): DocumentOutputLocation[] {
  return (dtos ?? []).map((dto) => mapFromDocumentOutputLocation(dto));
}

export function mapFromDocumentOutputLocationStatus(
  dto: DocumentOutputLocationStatusDTO,
): DocumentOutputLocationStatus {
  const output = new DocumentOutputLocationStatus();

  output.locationSet = dto.locationSet === true;
  output.reachable = dto.reachable === true;
  output.writeAccess = dto.writeAccess === true;
  output.templatePresent = dto.templatePresent ?? undefined;
  output.pdfAvailable = dto.pdfAvailable ?? undefined;
  output.message = dto.message;

  return output;
}

export function mapToDocumentOutputLocationPut(listId?: number, templateLinkId?: number): DocumentOutputLocationPutDTO {
  const output = new DocumentOutputLocationPutDTO();

  output.listId = listId ?? null;
  output.templateLinkId = templateLinkId ?? null;

  return output;
}

export function mapToDocumentOutputLocationFolderPut(
  folderDriveItemId?: string,
  folderName?: string,
): DocumentOutputLocationFolderPutDTO {
  const output = new DocumentOutputLocationFolderPutDTO();

  output.folderDriveItemId = folderDriveItemId ?? null;
  output.folderName = folderDriveItemId ? folderName ?? null : null;

  return output;
}

export function mapFromDocumentOutputLocationSummaries(
  dtos: DocumentOutputLocationSummaryDTO[],
): DocumentOutputLocationSummary[] {
  return (dtos ?? []).map((dto) => {
    const output = new DocumentOutputLocationSummary();

    output.purpose = dto.purpose as DocumentOutputPurpose;
    output.listId = dto.listId;
    output.listName = dto.listName;
    output.providerType = dto.providerType as DocumentProviderType | undefined;
    output.folderDriveItemId = dto.folderDriveItemId;
    output.folderName = dto.folderName;

    return output;
  });
}
